module.exports = __webpack_public_path__ + "img/message_select.fac40166.png";